<div class="modal ontop" role="dialog" [ngStyle]="{'display': showModal ? 'block': 'none'}" id="search-modal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Find tasks</h5>
        <button type="button" class="btn btn-close btn-outline-secondary" (click)="closeModal()">
        </button>
      </div>
      @if (canAddNewContent) {
        <!--div class=" m-2">
          <button class="btn my-btn" (click)="sendAddNewPost()">
            Add new post
            <span class="material-symbols--post-add ms-1"></span>
          </button>
        </div-->
      }
      <div class="modal-body">
        Search tasks:
        <form class="nav-item d-flex me-auto mt-2 mx-2" role="search" (submit)="filterPosts(userQuery)" style="width: 300px;">
          <div class="input-group mb-3 form-group-sm">
            <input id="searchinput" class="form-control form-control-sm input-sm" type="search" placeholder="Filter posts by words" aria-label="Search" [(ngModel)]="userQuery" name="searchQuery" (keydown.enter)="filterPosts(userQuery)" (ngModelChange)="filterOnInputChange($event)" >
            <button class="btn btn-secondary btn-sm" type="submit">
              <i class="bi bi-search"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" title="Add posts to book and close popup" data-bs-delay="{show: 1000}" (click)="addWorkpackages()">
              <i class="bi bi-plus" ></i>
            </button>
          </div>
        </form>
        @if (workpackages.length == 0) {
          <div class="m-2">
            {{message}}
          </div>
        }
        <ul class="list-group m-1">
          @for (u of workpackages; track u.key; let i = $index) {
            <li class="list-group-item" (click)="checkName(u.key)">
              <input class="form-check-input" type="checkbox" [(ngModel)]="u.isChecked" id="flexCheckDefault">
              <span [innerHTML]="u.nameHTML.slice(0, 100)">
              </span>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>